'use strict';

const Splunk = require('@splunk/otel-web');

const SplunkRum = {
    init: function () {
        if (SitePreferences.SPLUNK_CONFIG) {
            const {
                splunkSGRealm,
                splunkSGRumAccessToken,
                splunkSGApplicationName,
                splunkSGDeploymentEnvironment,
                isSplunkSGEnabled
            } = SitePreferences.SPLUNK_CONFIG;

            if (isSplunkSGEnabled) {
                Splunk.SplunkRum.init({
                    realm: splunkSGRealm,
                    rumAccessToken: splunkSGRumAccessToken,
                    applicationName: splunkSGApplicationName,
                    deploymentEnvironment: splunkSGDeploymentEnvironment
                });
            }
        }
    }
};

module.exports = SplunkRum;
